import { useEffect, useState } from 'react'
import ModalContainerModule from '../../../modules/modalContainer'
import { ResponsiveRow } from '../../../../constants/layout.constants'
import { Alert, AlertTitle, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import { DocumentStore } from '../../../documentStore'
import { formatCurrency, stringToFloat, tryParseFloat } from '../../../../util/util'
import { useSelector } from 'react-redux'

function CreateRSRInvoiceModal(props) {
  const user = useSelector(state => state.auth.user)
  const [rsrTableRows, setRsrTableRows] = useState(null)
  const [rsrTotal, setRsrTotal] = useState(0)
  const [chargeItems, setChargeItems] = useState(props?.rsr.leaseCharges)
  const [vatPercentage,] = useState(props?.rsr?.vatPercentage)

  useEffect(() => {
    if (chargeItems && chargeItems.length > 0) {
      populateLeaseChargeItems()
    }
  }, [chargeItems])

  const handleRevenueForPeriodChange = (event, index) => {
  const value = event.target.value
  if(!isNaN(value)){
   const tmp = [...chargeItems]
      tmp[index] = {
        ...tmp[index],
        revenueForThePeriod: stringToFloat(value)
      }
      const rsrRent = tmp[index].revenueForThePeriod * tmp[index]?.revSharePercentage / 100
      if(tmp[index].taxable) {
        tmp[index].vat = Math.max(rsrRent, tmp[index].amount) * vatPercentage
      } else {
        tmp[index].vat = 0
      }
      tmp[index].total = Math.max(rsrRent, tmp[index].amount) + (tmp[index].vat ?? 0)
      setChargeItems(tmp)
  }
  }

  function populateLeaseChargeItems() {
    let rows = ""
    let total = 0
    chargeItems &&
      chargeItems.length > 0 &&
      (rows = chargeItems.map(function (charge, i) {
        let amount = tryParseFloat(charge.total ?? charge.amount, -1)
        if (amount > 0) {
          total = total + amount
        }
        let serviceChargeVat = 0
        if(charge?.chargeCode === "SERCH") {
          serviceChargeVat = charge?.amount * vatPercentage 
          total = total + serviceChargeVat
        }
        return (
          <TableRow key={i}>
            <TableCell>
              <Tooltip title={charge?.unitName}>
                <TextField
                  sx={{ width: "90%" }}
                  id={"unit" + i}
                  name={"unit" + i}
                  isrequired={true}
                  disabled={true}
                  value={charge?.unitName}
                />
              </Tooltip>
            </TableCell>
            <TableCell>
              <Tooltip title={charge?.charge?.name}>
                <TextField
                  sx={{ width: "90%" }}
                  id={"chargeCode" + i}
                  name={"chargeCode" + i}
                  isrequired={true}
                  disabled={true}
                  value={charge?.charge?.name}
                />
              </Tooltip>
            </TableCell>
            <TableCell>
              {charge.chargeCode === "REN" && (
                <TextField
                  sx={{ width: "90%" }}
                  id={"revenueForPeriod" + i}
                  name={"revenueForPeriod" + i}
                  isrequired={true}
                  disabled={false}
                  type="number"
                  value={charge?.revenueForThePeriod}
                  onChange={(event) => handleRevenueForPeriodChange(event, i)}
                />
              )}
            </TableCell>
            <TableCell>
              {charge.chargeCode === "REN" && (
                <Tooltip title={`${charge?.revSharePercentage}%`}>
                  <TextField
                    sx={{ width: "90%" }}
                    id={"revenueShare"}
                    name={"revenueShare"}
                    disabled={true}
                    value={charge?.revSharePercentage}
                  />
                </Tooltip>
              )}
            </TableCell>
            <TableCell>
              {(charge.chargeCode === "SERCH" ||
                charge.chargeCode === "REN" ||
                charge.chargeCode === "ELCUT") && (
                <Switch
                  checked={charge?.taxable}
                  disabled={true}
                  inputProps={{ "aria-label": "controlled" }}
                />
              )}
            </TableCell>
            <TableCell>
              {(charge.chargeCode === "SERCH" ||
                charge.chargeCode === "REN" ||
                charge.chargeCode === "ELCUT") && (
                <Tooltip title={charge?.chargeCode === "SERCH" ? serviceChargeVat : charge?.vat ?? 0}>
                  <TextField
                    sx={{ width: "90%" }}
                    id={"vat" + i}
                    name={"vat" + i}
                    isrequired={true}
                    disabled={true}
                    value={charge?.chargeCode === "SERCH" ? serviceChargeVat : charge?.vat ?? 0}
                  />
                </Tooltip>
              )}
            </TableCell>
            <TableCell>
              <Tooltip title={charge?.total ?? charge?.amount}>
                <TextField
                  sx={{ width: "90%" }}
                  id={"total" + i}
                  name={"total" + i}
                  isrequired={true}
                  disabled={true}
                  value={charge.total ?? charge?.amount}
                />
              </Tooltip>
            </TableCell>
          </TableRow>
        )
      }, this))
    setRsrTableRows(rows)
    setRsrTotal(total)
  }

  return (
    <ModalContainerModule
      size="md"
      accept={() => props.saveInvoiceClicked(chargeItems)}
      cancel={props.handleCancelClicked}
      openModal={props.showAddInvoiceForm}
      modalTitle={
        props.task === "Create"
          ? user.proxyRole === "BLDIR" ? `Create Revenue Sharing Invoice for Unit: ${props.rsr.unitName} - ${props.rsr.tenantName}` : `Complete Revenue Sharing for Unit: ${props.rsr.unitName} - ${props.rsr.tenantName}`
          : `Edit Revenue Sharing for Unit: ${props.rsr.unitName} - ${props.rsr.tenantName}`
      }
      acceptButtonText={props.task === "Create" ? "Save" : "Update"}
    >
      <ResponsiveRow container>
        <Alert severity="info" sx={{ marginBottom: "25px", width: "100%" }}>
          <AlertTitle>Important</AlertTitle>
          <p>
            Please ensure that the following information is accurate before
            saving the invoice:
            <ul>
              <li>Revenue for the period</li>
              <li>Revenue Share Percentage</li>
              <li>Revenue Share Amount</li>
            </ul>
            Utility charges are not displayed.
          </p>
        </Alert>
        <ResponsiveRow
          sx={{
            height: "fit-content",
            width: "100%",
          }}
        >
          <Paper
            variant=""
            sx={{
              width: "100%",
              height: "auto",
              margin: "auto",
              padding: "10px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{ marginBottom: "5px" }}
              id="modal-modal-title"
              variant="h5"
              component="h4"
            >
              Revenue Details
            </Typography>
            <TableContainer>
              <Table
                sx={{ minWidth: 650, marginBottom: "10px" }}
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: "13%" }}>Unit</TableCell>
                    <TableCell sx={{ width: "13%" }}>Charge Type</TableCell>
                    <TableCell sx={{ width: "20%" }}>Revenue</TableCell>
                    <TableCell sx={{ width: "10%" }}>Revenue Share(%)</TableCell>
                    <TableCell sx={{ width: "7%" }}>Taxed?</TableCell>
                    <TableCell sx={{ width: "20%" }}>VAT</TableCell>
                    <TableCell sx={{ width: "20%" }}>Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>{rsrTableRows}</TableBody>
              </Table>
              <ResponsiveRow sx={{ width: '100%' }}>
                <b>Total</b> {`: KES ${formatCurrency(rsrTotal)}`}
              </ResponsiveRow>
            </TableContainer>
          </Paper>
          <ResponsiveRow sx={{ width: "100%", padding: 0 }} container>
            <>
              <Alert
                severity="info"
                sx={{ marginBottom: "15px", width: "100%" }}
              >
                <AlertTitle>You can attach supporting Documents</AlertTitle>
                You can upload supporting documents to support the declared
                revenue for the period.
              </Alert>

              <DocumentStore
                files={
                  props?.rsr?.imageFiles && props?.rsr?.otherDocuments
                    ? [...props?.rsr?.imageFiles, ...props?.rsr?.otherDocuments]
                    : []
                }
                item={props.rsr}
                type={"RSR Invoice"}
                disableShadow
                height="300px"
                maxWidth="100%"
                horizontalLayout={true}
              />
            </>
          </ResponsiveRow>
        </ResponsiveRow>
      </ResponsiveRow>
    </ModalContainerModule>
  );
}

export default CreateRSRInvoiceModal